import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import { StepButton, Button } from "@mui/material";

import IntroSkillPage from "../pages/intro_skill_page";
import WhereDoIStandPage from "../pages/intro_where_do_i_stand_page";
import ConclusionPage from "../pages/conclusion_page";
import IntoThemaPage from "../pages/intro_thema_page";
import ExcerciseChoicePage from "../pages/excercise_choice_page";
import ExcerciseResponsePage from "../pages/excercise_response_page";
import StartSkillPage from "../pages/start_skill_page";
import IntroductionExcercisePage from "../pages/introduction_excercise_page";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Choices } from '../enums';
import { getConfigText, getExcerciseChoiceConfig, getExcerciseText, isEmpty, isIntroException } from '../utils';
import { palette } from "../palette";
import Grid from "@mui/material/Grid";
import IntroductionExcerciseResponsePage from "../pages/introduction_excercise_response_page";


export default function VerticalNavMenu({ skillId, activeStep, setActiveStep }) {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panelId) => (event, isExpanded) => {
        setExpanded(isExpanded ? panelId : false);

    };

    // excerciseId holds the id of the active/last 'oefening'
    const [excerciseId, setExcerciseId] = React.useState(0);

    // selectedChoice holds the choice the student made by the last excerise
    const [selectedChoice, setSelectedChoice] = React.useState(null);
    const [isOtherVideoVisible, setOtherVideoVisible] = React.useState(false);
    const [isNextPageButtonVisible, setNextPageButtonVisible] = React.useState(true);

    const defaultStudentAnswers = {
        // stores answers of the first (waar sta ik nu) page
        a1: '',
        a2: '',
        // stores answers of the last (terugblik) page
        b1: '',
        b2: '',
    }
    const [studentAnswers, setStudentAnswers] = React.useState(() => {
        const saved = localStorage.getItem("studentAnswers");
        const initialValue = JSON.parse(saved);
        return initialValue || defaultStudentAnswers;
    });
    // Using a hook for storing changes made to studentAnswers 
    React.useEffect(() => {
        localStorage.setItem("studentAnswers", JSON.stringify(studentAnswers));
    }, [JSON.stringify(studentAnswers)]);


    const getPanelPages = (panelId) => {
        return pages.filter(p => p.parent === panelId);
    }
    const getVisiblePages = (panelId) => {
        return getPanelPages(panelId).filter(p => p.isVisible);
    }

    const handleNext = () => {
        setStep(activeStep + 1);
    };
    const handleStep = (step) => {
        let nextPage = getPage(step);
        if (nextPage.label === 'Feedback') {
            // Can not click on the feedback page, because a choice must have been made, and we dont store the previous choices.
            // simple hack is to disable the navigation to the feedback page.
            return;
        }
        setStep(step)
    };
    const setStep = (newStep) => {
        setActiveStep(newStep);

        setOtherVideoVisible(false);
        setNextPageButtonVisible(true);

        let page = getPage(newStep);
        setExpanded(page.parent);
        setExcerciseId(page.excerciseId);
    }
    const isCompleted = (pageNr) => {
        return activeStep > pageNr ? true : false;
    }
    const isActive = (pageNr) => {
        return activeStep == pageNr ? true : false;
    }
    const getPage = (pageNr) => {
        return pages.find(p => p.nr === pageNr);
    }
    const getCurrentPage = () => {
        return getPage(activeStep);
    }
    const menuActiveStep = (panelId) => {
        let currentPage = getPage(activeStep);
        if (!currentPage) {
            return 0;
        }
        if (currentPage.parent != panelId) {
            return -1;
        }
        let pages = getPanelPages(panelId);
        for (let i = 0; i < pages.length; i++) {
            if (pages[i].nr == activeStep) {
                return i;
            }
        }
        return 0;
    }
    const getActivePages = () => {
        let currentPage = getPage(activeStep);
        return getPanelPages(currentPage.parent);
    }

    const getContent = () => {
        return getCurrentPage().content;
    }
    const lastPageNr = () => {
        return pages[pages.length - 1].nr;
    }

    const setChoice = (choice) => {
        setSelectedChoice(choice);
        handleNext();
    }

    const showOtherVideo = () => {
        setNextPageButtonVisible(false);
        setOtherVideoVisible(true);
    }

    const handleNextExcercise = () => {
        setSelectedChoice(null);
        setExcerciseId(excerciseId + 1);
        let currentPage = getPage(activeStep);
        let nextPageNr = activeStep + (currentPage.isVisible ? 2 : 1);
        setStep(nextPageNr);
    }

    const resetExcercise = () => {
        setStudentAnswers(defaultStudentAnswers);
        setSelectedChoice(null);
        setExcerciseId(0);
        setStep(0);
    }

    let excercises = getConfigText(skillId, 'oefeningen');
    const lastExcerciseId = () => {
        return excercises.length - 1;
    }

    const NextPageButton = () => {
        let button = null;
        let currentPage = getCurrentPage();

        if (isNextPageButtonVisible === false) {
            return null;
        }

        // General button behaviour
        if (activeStep < lastPageNr()) {
            button =
                <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 3, ml: 1 }}
                >
                    Volgende
                </Button>;
        } else {
            button =
                <Button
                    variant="contained"
                    onClick={resetExcercise}
                    sx={{ mt: 3, ml: 1 }}
                >
                    Begin opnieuw
                </Button>
        }

        // Button overwrites for specific pages
        if (currentPage.label === 'Vraag') {
            button = null;
        }
        if (currentPage.label === 'Feedback') {
            let correctAnswer = getExcerciseText(skillId, excerciseId, 'juiste_antwoord').toUpperCase();
            if (selectedChoice == correctAnswer || isOtherVideoVisible) {
                let buttonText = 'Ga naar volgende oefening';

                // Because the page 'samenvatting' was added after the last excercise, change the text of the button
                if (excerciseId === lastExcerciseId()) {
                    buttonText = 'Volgende';
                }
                button =
                    <Button
                        variant="contained"
                        onClick={handleNextExcercise}
                        sx={{ mt: 3, ml: 1 }}
                    >
                        {buttonText}
                    </Button>;
            } else if (selectedChoice != correctAnswer) {
                button =
                    <Button
                        variant="contained"
                        onClick={() => { showOtherVideo(); }}
                        sx={{ mt: 3, ml: 1 }}
                    >
                        Bekijk de andere video
                    </Button>;
            }
        }
        return button;
    }

    let pages = [];
    pages.push(
        {
            label: 'Inleiding',
            parent: 'panel1',
            nr: pages.length,
            content: <IntoThemaPage pageId={skillId} />,
            excerciseId: 0,
            isVisible: true
        }
    )
    pages.push(
        {
            label: 'Waar sta ik nu?',
            parent: 'panel1',
            nr: pages.length,
            content: <WhereDoIStandPage pageId={skillId} studentAnswers={studentAnswers} setStudentAnswers={setStudentAnswers} />,
            excerciseId: 0,
            isVisible: true
        },
    )
    pages.push(
        {
            label: 'Vaardigheden en leerdoelen',
            parent: 'panel1',
            nr: pages.length,
            content: <IntroSkillPage pageId={skillId} />,
            excerciseId: 0,
            isVisible: true
        },
    )
    pages.push(
        {
            label: 'Start oefening',
            parent: 'panel1.1',
            nr: pages.length,
            content: <StartSkillPage pageId={skillId} />,
            excerciseId: 0,
            isVisible: true
        },
    )



    const addExcercisePages = (pages, excercises) => {
        let i = 0;
        excercises.forEach(e => {
            let panelId = 'panel_' + (e.id);
            pages.push(
                {
                    label: 'Vraag',
                    parent: panelId,
                    nr: pages.length,
                    content: <ExcerciseChoicePage pageId={skillId} excerciseId={i} setChoice={setChoice} />,
                    excerciseId: i,
                    isVisible: true
                }
            )
            pages.push(
                {
                    label: 'Feedback',
                    parent: panelId,
                    nr: pages.length,
                    content: <ExcerciseResponsePage key={"response_page_" + pages.length} pageId={skillId} excerciseId={i} choice={selectedChoice} showfeedback={true} showOtherVideo={isOtherVideoVisible} setNextPageButtonVisible={setNextPageButtonVisible} />,
                    excerciseId: i,
                    isVisible: true
                }
            )
            pages.push(
                {
                    label: 'Feedback',
                    parent: panelId,
                    nr: pages.length,
                    content: <ExcerciseResponsePage key={"response_page_" + pages.length} pageId={skillId} excerciseId={i} choice={selectedChoice} showfeedback={false} />,
                    isVisible: false
                }
            )

            i++;
        });
    }
    addExcercisePages(pages, excercises);

    if (isIntroException(skillId)) {
        // rebuild the pages for the introduction module
        pages = [];

        pages.push(
            {
                label: 'Inleiding',
                parent: 'panel1',
                nr: pages.length,
                content: <IntoThemaPage pageId={skillId} />,
                excerciseId: 0,
                isVisible: true
            }
        )
        pages.push(
            {
                label: 'Leerdoelen',
                parent: 'panel1',
                nr: pages.length,
                content: <IntroSkillPage pageId={skillId} />,
                excerciseId: 0,
                isVisible: true
            },
        )
        
        let i = 0;
        excercises.forEach(e => {
            let panelId = 'panel_' + (e.id);
            pages.push(
                {
                    label: 'Vraag',
                    parent: panelId,
                    nr: pages.length,
                    content: <IntroductionExcercisePage pageId={skillId} excerciseId={i} setChoice={setChoice} />,
                    excerciseId: i,
                    isVisible: true
                }
            )
            
            // Only add the feedback page for oefening 2
            let feedbackTxt = getExcerciseChoiceConfig(skillId, i, Choices.A)['feedback']
            if(!isEmpty(feedbackTxt)) {
                
                pages.push(
                    {
                        label: 'Feedback',
                        parent: panelId,
                        nr: pages.length,
                        content: <IntroductionExcerciseResponsePage key={"response_page_" + pages.length} pageId={skillId} excerciseId={i} choice={selectedChoice} showfeedback={true} showOtherVideo={isOtherVideoVisible} setNextPageButtonVisible={setNextPageButtonVisible} />,
                        excerciseId: i,
                        isVisible: true
                    }
                )
                //Don't know why, but needs this page to be here after the feedback page
                pages.push(
                    {
                        label: 'Feedback',
                        parent: panelId,
                        nr: pages.length,
                        content: <ExcerciseResponsePage key={"response_page_" + pages.length} pageId={skillId} excerciseId={i} choice={selectedChoice} showfeedback={false} />,
                        isVisible: false
                    }
                )                                
            }
            i++;
        });        

    }

    // Add the 'Terugblik' page to the end of the array
    pages.push(
        {
            label: 'Terugblik',
            parent: 'panel1.2',
            nr: pages.length,
            content: <ConclusionPage pageId={skillId} studentAnswers={studentAnswers} setStudentAnswers={setStudentAnswers} />,
            isVisible: true,
        });



    const styles = {
        accordion_active: {
            backgroundColor: '#CCECF9',
        },
        step_active: {
            backgroundColor: '#8ED6F2',
        }
    }

    const MenuItem = ({ label, panelId }) => {
        if (panelId == 'panel1.1' && isIntroException(skillId)) {
            return null;
        }

        return <Accordion
            expanded={expanded === panelId}
            onChange={handleChange(panelId)}
            style={getPage(activeStep).parent === panelId ? styles.accordion_active : null}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
            >
                <Typography>
                    {label}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stepper
                    nonLinear
                    //activeStep={activeStep}
                    activeStep={menuActiveStep(panelId)}
                    orientation="vertical"
                    sx={{ pt: 0, pb: 0, ml: 1, mt: -2, mb: -1 }}
                >
                    {getVisiblePages(panelId).map((page, index) => (
                        <Step
                            key={panelId + "step_" + page.nr}
                            index={index}
                            completed={isCompleted(page.nr)}
                            style={isActive(page.nr) ? styles.step_active : null}
                            sx={{ ml: -3, pl: 3, mr: -2, mt: -1, mb: -1 }}
                        >
                            <StepButton onClick={() => handleStep(page.nr)}>
                                {page.label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </AccordionDetails>
        </Accordion>
    };

    let excerisePanelIds = [];
    pages.forEach(p => {
        let panelId = p.parent;

        if (panelId === 'panel1') {
            // Skip the panelId from the introduction pages
            return;
        }
        if (panelId === 'panel1.1') {
            // Skip the panelId from the start oefening pages
            return;
        }
        if (panelId === 'panel1.2') {
            // Skip the panelId from the Terugblik pages
            return;
        }
        if (excerisePanelIds.indexOf(panelId) === -1) {
            excerisePanelIds.push(panelId);
        }
    });

    return (
        <Paper
            variant="outlined"
        //sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        //sx={{ pl: 3 }}
        >
            <Grid container >
                <Grid item xs={2}>
                    <MenuItem key="panel1" label="Introductie" panelId="panel1" />
                    <MenuItem key="panel1.1" label="Start oefening" panelId="panel1.1" />
                    {excerisePanelIds.map((p, index) => (
                        <MenuItem key={"oef" + index} label={"Oefening " + (index + 1)} panelId={p} />
                    ))}
                    <MenuItem key="panel1.2" label="Terugblik" panelId="panel1.2" />
                </Grid>
                <Grid item xs={10}>
                    <Paper
                        variant="outlined"
                        //sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
                        sx={{ p: 3 }}
                    >
                        <Typography
                            component="h1"
                            variant="h4"
                            align="center"
                            gutterBottom
                            sx={{
                                fontFamily: "HUsansNormal",
                                color: palette.HUBlauw,
                            }}
                        >
                            {getConfigText(skillId, 'thematitel')}
                        </Typography>

                        <React.Fragment>
                            {getContent()}

                            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <NextPageButton />
                            </Box>
                        </React.Fragment>
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    );
}
